import React from 'react';
import styled from 'styled-components';

import { IApplication } from '../../models';
import ApplicationCard from './ApplicationCard';

const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

interface IProps {
  applications: IApplication[];
  onApplicationClick: (application: IApplication) => void;
}

const ApplicationCardContainer: React.FC<IProps> = ({ applications, onApplicationClick }) => (
  <Container>
    {
      applications.map((application: IApplication) => {
        return (
          <ApplicationCard
            key={application.name}
            application={application}
            onClick={onApplicationClick}
          />
        );
      })
    }
  </Container>
);

export default ApplicationCardContainer;
